// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Bsc","placeholdersHeader":"styles_placeholdersHeader__33kgE","editorStyle":"styles_editorStyle__3AwvI","placeholdersBox":"styles_placeholdersBox__2csgS"};